import { Wine, MapPin } from "lucide-react";

const Bodega = () => {
  const wineRegions = [
    "Rioja",
    "Ribera del Duero",
    "Bierzo",
    "Valencia",
    "Campo de Borja",
    "Ribeiro",
    "Portugal",
    "Jerez",
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="bodega" className="section-padding bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div>
            <p className="font-accent text-[#800020] text-lg mb-4">
              Nuestra selección
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] mb-6">
              Bodega de Vinos en Sevilla Este
            </h2>

            <div className="gold-border-left mb-8">
              <p className="font-body text-[#1A1A1A]/80 leading-relaxed mb-4">
                En Abacería Como en Casa creemos que un gran plato merece un gran vino.
              </p>
              <p className="font-body text-[#1A1A1A]/80 leading-relaxed">
                Nuestra bodega reúne referencias cuidadosamente seleccionadas de
                diferentes denominaciones de origen.
              </p>
            </div>

            {/* Wine Regions */}
            <h3 className="font-accent text-lg text-[#1A1A1A] mb-4">
              Vinos de Rioja, Ribera del Duero y más:
            </h3>
            <div className="grid grid-cols-2 gap-3 mb-8">
              {wineRegions.map((region, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2"
                  data-testid={`wine-region-${index}`}
                >
                  <MapPin size={14} className="text-[#800020]" />
                  <span className="font-body text-[#1A1A1A]/80">{region}</span>
                </div>
              ))}
            </div>

            {/* Special wines */}
            <div className="bg-[#F9F7F2] p-6 mb-8">
              <p className="font-body text-[#1A1A1A]/80 text-sm mb-3">
                También contamos con una selección especial de:
              </p>
              <div className="flex flex-wrap gap-3">
                {["Champagne", "Cava", "Vinos de Jerez"].map((wine, index) => (
                  <span
                    key={index}
                    className="px-4 py-2 bg-white border border-[#C5A059] font-body text-sm text-[#1A1A1A]"
                  >
                    {wine}
                  </span>
                ))}
              </div>
            </div>

            <a
              href="#catas"
              onClick={(e) => scrollToSection(e, "#catas")}
              data-testid="bodega-cta"
              className="btn-primary inline-block"
            >
              Catas de Vino en Sevilla
            </a>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="img-zoom">
              <img
                src="https://images.unsplash.com/photo-1765033670303-3a1d62ae5cbd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxyZWQlMjB3aW5lJTIwZ2xhc3MlMjBwb3VyaW5nJTIwbHV4dXJ5JTIwYm90dGxlfGVufDB8fHx8MTc3MzM0NzQzOHww&ixlib=rb-4.1.0&q=85"
                alt="Vinos seleccionados en Sevilla Este"
                className="w-full h-[600px] object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-[#800020]/10 -z-10" />
            <div className="absolute -top-4 -right-4 flex items-center justify-center w-24 h-24 bg-[#800020] text-white">
              <div className="text-center">
                <Wine size={24} className="mx-auto mb-1" />
                <span className="font-body text-xs uppercase tracking-wider">
                  Premium
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bodega;
